import { useState, useEffect } from 'react';
import { SETTINGS_SUBTABS, TEAM, pillStyle } from './adminData';
import { useSite } from '../../data/SiteContext';
import { apiSend } from '../../data/api';
import { initialsOf } from './initials';
import logo from '../../assets/images/hola-caribe-logo.svg';

const panel = { padding:26, borderRadius:22 };

function InviteModal({ onClose }) {
  return (
    <div style={{ position:'fixed', inset:0, zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:24, background:'rgba(6,40,45,0.45)', backdropFilter:'blur(6px)', WebkitBackdropFilter:'blur(6px)' }}>
      <div style={{ width:'100%', maxWidth:460, padding:30, borderRadius:24, background:'rgba(255,255,255,0.82)', backdropFilter:'blur(30px) saturate(180%)', WebkitBackdropFilter:'blur(30px) saturate(180%)', border:'1px solid rgba(255,255,255,0.9)', boxShadow:'0 30px 70px rgba(6,40,45,0.35)', animation:'floatUp .3s ease both' }}>
        <div className="serif" style={{ fontSize:26, marginBottom:6 }}>Invite teammate</div>
        <div style={{ fontSize:14, color:'#5a726f', marginBottom:20 }}>They'll get an email invitation valid for 7 days.</div>
        <div style={{ display:'grid', gap:14 }}>
          <label style={{ display:'block' }}><span className="a-label">Email</span><input placeholder="name@holacaribe.travel" className="a-input" /></label>
          <label style={{ display:'block' }}><span className="a-label">Role</span><select className="a-input"><option>Editor — can manage content</option><option>Admin — full access</option><option>Viewer — read only</option></select></label>
          <div style={{ display:'flex', gap:10, marginTop:4 }}>
            <span onClick={onClose} className="a-ghost" style={{ flex:1, textAlign:'center', padding:13, borderRadius:13, fontSize:14 }}>Cancel</span>
            <span onClick={onClose} className="a-primary" style={{ flex:1, textAlign:'center', padding:13, borderRadius:13, fontSize:14 }}>Send invite</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const AGENCY_FORM_FIELDS = [
  ['brandName', 'Agency name'], ['whatsApp', 'WhatsApp number'], ['phone', 'Phone'],
  ['instagram', 'Instagram handle'], ['supportEmail', 'Support email'],
  ['officeAddress', 'Office address'], ['timezone', 'Timezone'], ['defaultCurrency', 'Default currency'],
];

const emptyPassword = { oldPassword:'', newPassword:'', newPasswordConfirmation:'' };

export default function Settings() {
  const { agency, updateAgency, me } = useSite();
  const [tab, setTab] = useState('profile');
  const [invite, setInvite] = useState(false);
  const subtabTitle = (SETTINGS_SUBTABS.find(x => x[0] === tab) || [])[1] || '';

  // ---- Change password ----
  const [pw, setPw] = useState(emptyPassword);
  const [pwStatus, setPwStatus] = useState(null); // null | 'saving' | 'saved' | error message
  const canSubmitPw = pw.oldPassword && pw.newPassword.length >= 8 && pw.newPassword === pw.newPasswordConfirmation;

  const changePassword = async () => {
    if (!canSubmitPw || pwStatus === 'saving') return;
    setPwStatus('saving');
    try {
      await apiSend('POST', '/api/admin/change-password', pw);
      setPw(emptyPassword);
      setPwStatus('saved');
      setTimeout(() => setPwStatus(null), 3000);
    } catch (e) { setPwStatus(e.message || 'The password could not be changed.'); }
  };

  const [ag, setAg] = useState({});
  const [agStatus, setAgStatus] = useState(null); // null | 'saving' | 'saved' | error
  useEffect(() => { if (agency) setAg(agency); }, [agency]);
  const saveAgency = async () => {
    if (agStatus === 'saving') return;
    setAgStatus('saving');
    try {
      await updateAgency({
        brandName: ag.brandName || 'HolaCaribe', whatsApp: ag.whatsApp || null, phone: ag.phone || null,
        instagram: ag.instagram || null, supportEmail: ag.supportEmail || null,
        officeAddress: ag.officeAddress || null, timezone: ag.timezone || null, defaultCurrency: ag.defaultCurrency || null,
      });
      setAgStatus('saved'); setTimeout(() => setAgStatus(null), 2500);
    } catch (e) { setAgStatus(e.message || 'Save failed.'); }
  };

  return (
    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:20, alignItems:'start' }}>
      <div className="glass" style={{ padding:16, borderRadius:20, display:'grid', gap:3 }}>
        {SETTINGS_SUBTABS.map(([k, label]) => (
          <span key={k} className={'a-subtab' + (tab === k ? ' active' : '')} onClick={() => setTab(k)}>{label}</span>
        ))}
      </div>

      <div style={{ gridColumn:'span 3', minWidth:0, display:'grid', gap:18 }}>
        {tab === 'profile' && (
          <div style={{ display:'grid', gap:18 }}>
            <div className="glass-card" style={panel}>
              <div style={{ display:'flex', alignItems:'center', gap:18, marginBottom:22, flexWrap:'wrap' }}>
                <div style={{ width:74, height:74, borderRadius:'50%', background:'linear-gradient(140deg,#26c6a3,#0e8a9c)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:26, boxShadow:'0 10px 24px rgba(14,138,156,0.3)' }}>{initialsOf(me?.name, me?.email)}</div>
                <div>
                  <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
                    <div className="serif" style={{ fontSize:23 }}>{me?.name || me?.email || 'Loading…'}</div>
                    {me?.role && <span style={{ padding:'4px 11px', borderRadius:100, background:'rgba(14,138,122,0.12)', color:'#0c6d7c', fontSize:11, fontWeight:800 }}>{me.role}</span>}
                  </div>
                  <div style={{ fontSize:13, color:'#5a726f', marginTop:6 }}>Signed in through StaffOptimize.Auth</div>
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(210px,1fr))', gap:14 }}>
                <label style={{ display:'block' }}><span className="a-label">Full name</span><input value={me?.name || ''} readOnly className="a-input" style={{ opacity:0.75 }} /></label>
                <label style={{ display:'block' }}><span className="a-label">Email</span><input value={me?.email || ''} readOnly className="a-input" style={{ opacity:0.75 }} /></label>
                <label style={{ display:'block' }}><span className="a-label">Role</span><input value={me?.role || ''} readOnly className="a-input" style={{ opacity:0.75 }} /></label>
              </div>
              <div style={{ fontSize:12.5, color:'#5a726f', marginTop:14 }}>Name, email and avatar are owned by the Auth service and are read-only here until it exposes profile editing.</div>
            </div>
            <div className="glass-card" style={panel}>
              <div style={{ fontWeight:800, fontSize:16, marginBottom:16 }}>Change password</div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(190px,1fr))', gap:14 }}>
                <label style={{ display:'block' }}><span className="a-label">Current password</span><input type="password" placeholder="••••••••" value={pw.oldPassword} onChange={e => setPw(p => ({ ...p, oldPassword:e.target.value }))} className="a-input" /></label>
                <label style={{ display:'block' }}><span className="a-label">New password</span><input type="password" placeholder="At least 8 characters" value={pw.newPassword} onChange={e => setPw(p => ({ ...p, newPassword:e.target.value }))} className="a-input" /></label>
                <label style={{ display:'block' }}><span className="a-label">Confirm new password</span><input type="password" placeholder="••••••••" value={pw.newPasswordConfirmation} onChange={e => setPw(p => ({ ...p, newPasswordConfirmation:e.target.value }))} className="a-input" /></label>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:18, flexWrap:'wrap' }}>
                <button onClick={changePassword} disabled={!canSubmitPw || pwStatus === 'saving'} className="a-primary" style={{ padding:'12px 24px', borderRadius:12, fontSize:14, opacity: (!canSubmitPw || pwStatus === 'saving') ? 0.55 : 1, cursor: canSubmitPw ? 'pointer' : 'not-allowed' }}>{pwStatus === 'saving' ? 'Updating…' : 'Update password'}</button>
                {pwStatus === 'saved' && <span style={{ color:'#1a7a48', fontWeight:700, fontSize:13.5 }}>✓ Password updated.</span>}
                {pwStatus && pwStatus !== 'saving' && pwStatus !== 'saved' && <span style={{ color:'#c0492f', fontWeight:700, fontSize:13.5 }}>{pwStatus}</span>}
                {!pwStatus && pw.newPassword && pw.newPassword !== pw.newPasswordConfirmation && <span style={{ color:'#5a726f', fontWeight:700, fontSize:13 }}>The new passwords do not match yet.</span>}
              </div>
            </div>
          </div>
        )}

        {tab === 'agency' && (
          <div className="glass-card" style={panel}>
            <div style={{ fontWeight:800, fontSize:16, marginBottom:6 }}>Agency details</div>
            <div style={{ fontSize:13, color:'#5a726f', marginBottom:18 }}>These values feed the public site's header, footer and contact page.</div>
            <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:18, flexWrap:'wrap' }}>
              {/* Light glass panel — the white-text logo needs the brand-gradient tile behind it. */}
              <div style={{ width:84, height:76, borderRadius:18, background:'linear-gradient(140deg,#26c6a3,#0e8a9c)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <img src={logo} alt="HolaCaribe" style={{ height:58, display:'block' }} />
              </div>
              <div><div style={{ fontWeight:800, fontSize:14.5, marginBottom:6 }}>Agency logo</div><span className="a-primary" style={{ padding:'9px 15px', borderRadius:11, fontSize:13 }}>Upload new logo</span></div>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(210px,1fr))', gap:14 }}>
              {AGENCY_FORM_FIELDS.map(([key, label]) => (
                <label key={key} style={{ display:'block' }}><span className="a-label">{label}</span><input value={ag[key] ?? ''} onChange={e => setAg(prev => ({ ...prev, [key]: e.target.value }))} className="a-input" /></label>
              ))}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:18 }}>
              <button onClick={saveAgency} disabled={agStatus === 'saving'} className="a-primary" style={{ padding:'12px 24px', borderRadius:12, fontSize:14, opacity: agStatus === 'saving' ? 0.7 : 1 }}>{agStatus === 'saving' ? 'Saving…' : 'Save agency details'}</button>
              {agStatus === 'saved' && <span style={{ color:'#1a7a48', fontWeight:700, fontSize:13.5 }}>✓ Saved — the public site now shows these.</span>}
              {agStatus && agStatus !== 'saving' && agStatus !== 'saved' && <span style={{ color:'#c0492f', fontWeight:700, fontSize:13.5 }}>{agStatus}</span>}
            </div>
          </div>
        )}

        {tab === 'team' && (
          <div style={{ display:'grid', gap:16 }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' }}>
              <div style={{ fontSize:13.5, color:'#5a726f', fontWeight:600 }}>Sample list — the Auth service does not yet expose product-user listing or invites</div>
              <span onClick={() => setInvite(true)} className="a-primary" style={{ marginLeft:'auto', padding:'12px 20px', borderRadius:12, fontSize:13.5 }}>+ Invite teammate</span>
            </div>
            <div className="glass-card" style={{ padding:'6px 22px 14px', borderRadius:22, overflowX:'auto' }}>
              <table className="a-table" style={{ minWidth:520 }}>
                <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th></th></tr></thead>
                <tbody>
                  {TEAM.map(m => (
                    <tr key={m.email}>
                      <td><div style={{ display:'flex', alignItems:'center', gap:11 }}><div style={{ width:34, height:34, borderRadius:'50%', background:'linear-gradient(140deg,#26c6a3,#0e8a9c)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:12.5, flexShrink:0 }}>{m.initials}</div><span style={{ fontWeight:800 }}>{m.name}</span></div></td>
                      <td style={{ color:'#5a726f' }}>{m.email}</td>
                      <td><span style={{ padding:'5px 11px', borderRadius:100, background:'rgba(14,138,122,0.12)', color:'#0c6d7c', fontSize:11.5, fontWeight:800 }}>{m.role}</span></td>
                      <td><span style={pillStyle(m.status === 'Active' ? 'Live' : 'Invited')}>{m.status}</span></td>
                      <td style={{ textAlign:'right' }}><span style={{ cursor:'pointer', color:'#0e8a9c', fontWeight:800, fontSize:13 }}>Manage</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {['notifications', 'integrations', 'billing'].includes(tab) && (
          <div className="glass" style={{ padding:'56px 24px 62px', textAlign:'center', borderRadius:22 }}>
            <div style={{ width:70, height:70, borderRadius:22, margin:'0 auto 16px', background:'rgba(14,138,122,0.1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:28 }}>⚙</div>
            <div className="serif" style={{ fontSize:23, marginBottom:8 }}>{subtabTitle}</div>
            <div style={{ fontSize:14.5, color:'#5a726f', maxWidth:'40ch', margin:'0 auto', lineHeight:1.6 }}>This section is part of the next release. Profile, Agency and Team are ready to use today.</div>
          </div>
        )}

      </div>

      {invite && <InviteModal onClose={() => setInvite(false)} />}
    </div>
  );
}
